import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Button } from "../../bootstrap/index.jsx";
import Select from "../../common/Select.jsx";
import ToggleSwitch, { TextOptionElem } from "../../common/ToggleSwitch.jsx";
import ActionButtons from "./ActionButtons.jsx";
import Tooltip from "../../common/Tooltip.jsx";

import { ACTION_TYPES } from "./phaseReducer.js";
import FormList from "./FormList.jsx";
import { ReadOnlyMultiSelectValues } from "../../common/Select.jsx";
import { displayFormField, displayPreFillContent } from "./FillPhaseEdit.jsx";
import FormDataCaptureList from './FormDataCaptureList.jsx';
import {DeadlineReminderEdit} from './FillPhaseEdit.jsx'
import dayjs from "dayjs";
import PreFillContextList from './PreFillContextList.jsx';

import PhaseCollapser from "./PhaseCollapser.jsx";
import { buildAssigneeOptions, parseAssigneeSelection, findAssigneeDetails, toAssigneeValue } from "./phaseAssignees.js";
import { PhaseSectionElement } from "./PhaseSectionElement.jsx";

import { monitoring_report_update_phase_path } from '~/routes';

const GeneralDetails = ({ report, phase, generalFormRef, advancedFormRef, formOptions, dispatch, formRef, editMode, setEditMode }) => {
  const [reviewers, setReviewers] = useState(
    ((phase.body || {}).reviewers || []).map((r) => ({ type: r.type, id: parseInt(r.id, 10) }))
  );
  const [name, setName] = useState((phase.body || {}).name || "");

  const [reviewTime, setReviewTime] = useState(
    (phase.body || {}).review_time || dayjs().utc().format('YYYY-MM-DD HH:mm:ss')
  );

  const handleReviewerSelect = (selected) => {
    setReviewers((prev) => parseAssigneeSelection(selected, prev));
  };

  const onSave = (e) => {
    e.preventDefault();
    const serializedData = jQuery(generalFormRef.current).serialize() + '&' + jQuery(advancedFormRef.current).serialize();
    jQuery.post(
      monitoring_report_update_phase_path({
        id: report.id,
        phase_id: phase.id,
        _options: true,
      }),
      serializedData,
      (res) => {
        setEditMode(false);
        dispatch({ type: ACTION_TYPES.UPDATE_DATA, payload: { data: res.data } });
      }
    );
  };

  const reviewerDetails = findAssigneeDetails(reviewers, formOptions.available_reviewers, formOptions.available_work_queues);

  return (
    <form ref={generalFormRef}>
      <Row>
        {
          reviewers.length > 0 &&
          (
            <Col style={{ display: "none"}}>
              <input type="text" onChange={setReviewTime} value={reviewTime} name="monitoring_report[review_time]" className="form-control"></input>
            </Col>
          )
        }

        <Col>
          <h3 style={{ display: "inline-block" }}>{I18n.t("general")}</h3>
          {!editMode && (
            <Button
              className="pull-right"
              onClick={(e) => {
                e.preventDefault();
                setEditMode(!editMode);
              }}
            >
              <i className="fa fa-pencil" />
            </Button>
          )}
        
          {editMode && (
            <ActionButtons
              onSave={onSave}
              onCancel={(e) => {
                e.preventDefault();
                Turbo.visit(location.href);
                setEditMode(!editMode);
              }}
            />
          )}
        </Col>

        <Col size="xs-12" className="mb-1">
          <label>{I18n.t("name")}</label>
          {editMode ? (
            <input
              type="text"
              className="form-control"
              name="monitoring_report[name]"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          ) : (
            <p>{name || "-"}</p>
          )}
          {editMode && <p className="description">{I18n.t("name_description")}</p>}
        </Col>

        <Col size="xs-12" className="mb-1">
          <div>
            <label>{I18n.t("reviewers")}</label>
          </div>
          {editMode ? (
            <>
              <Select
                options={buildAssigneeOptions(formOptions.available_reviewers, formOptions.available_work_queues)}
                value={reviewers.map(toAssigneeValue)}
                onChange={handleReviewerSelect}
                isMulti
              />
              {reviewers.map((r) => (
                <div key={`${r.type}-${r.id}`} className="visibility-hidden">
                  <input type="hidden" name="monitoring_report[reviewers][][id]" value={r.id} />
                  <input type="hidden" name="monitoring_report[reviewers][][type]" value={r.type} />
                </div>
              ))}
            </>
          ) : reviewers.length > 0 ? (
            <ReadOnlyMultiSelectValues values={reviewerDetails} />
          ) : (
            <p>-</p>
          )}
          {editMode && <p className="description">{I18n.t("reviewers_description")}</p>}
        </Col>
      </Row>
    </form>
    );
  };

  const AdvancedOptions = ({ editMode, dispatch, report, phase, fillPhase, formRef, formOptions, tenantConfirmEmailProcessedSub = false }) => {
    const [mayEditReport, setMayEditReport] = useState((phase.body || {}).may_edit_report || false);
    const [longestDelayLimit, setLongestDelayLimit] = useState(
      (phase.body || {}).longest_delay_limit || false
    );
    const [deadlineReminders, setDeadlineReminders] = useState((phase.body || {})?.deadline_reminders || [])
    const [mayProceedAsReviewed, setMayProceedAsReviewed] = useState((phase.body || {}).allow_proceed_as_reviewed || false);

    const [visibleForms, setVisibleForms] = useState(
      ((phase.body || {}).visible_forms || []).map((r) => parseInt(r, 10))
    );
    const [automaticApproval, setAutomaticApproval] = useState(
      (phase.body || {}).automatic_approval || false
    );
    const [automaticSkipReview, setAutomaticSkipReview] = useState(
      (phase.body || {}).automatic_skip_review || false
    );
    const [selectFollowingPhases, setSelectFollowingPhases] = useState(
      (phase.body || {}).select_following_phases || false
    );
    const [skipIfPreviousSkipped, setSkipIfPreviousSkipped] = useState(
      (phase.body || {}).skip_if_previous_skipped || false
    );
    const [confirmEmailProcessedSubmission, setConfirmEmailProcessedSubmission] = useState(
      tenantConfirmEmailProcessedSub ? true : ((phase.body || {}).confirm_email_processed_submission || false)
    );
    const [lockFormFill, setLockFormFill] = useState(
      (phase.body || {}).lock_form_fill || false
    );
    
    const handleVisibleFormSelect = (selected) => {
      setVisibleForms(selected);
    };

    const handleMayEditReportToggle = () => {
      setMayEditReport(!mayEditReport);
    };


    return (
      <>
      <Row>
      <form ref={formRef}>
        <Col size="xs-12" className="mb-1">
          <PhaseSectionElement title_key='automatic_approval' />
          {editMode ? (
            <div>
              <ToggleSwitch
                isOn={automaticApproval}
                handleToggle={() => setAutomaticApproval(!automaticApproval)}
                name="monitoring_report[automatic_approval]"
                yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
              />
            </div>
          ) : (
            <p>{automaticApproval ? I18n.t("option_yes") : I18n.t("option_no")}</p>
          )}
        </Col>

        <Col size="xs-12" className="mb-1">
          <PhaseSectionElement title_key='allow_selecting_following_review_phases' />
          {editMode ? (
            <div>
              <ToggleSwitch
                isOn={selectFollowingPhases}
                handleToggle={() => setSelectFollowingPhases(!selectFollowingPhases)}
                name="monitoring_report[select_following_phases]"
                yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
              />
            </div>
          ) : (
            <p>{selectFollowingPhases ? I18n.t("option_yes") : I18n.t("option_no")}</p>
          )}
        </Col>

        <Col size="xs-12" className="mb-1">
          <PhaseSectionElement title_key='skip_phase_if_previous_phase_skipped' />
          {editMode ? (
            <div>
              <ToggleSwitch
                isOn={skipIfPreviousSkipped}
                handleToggle={() => setSkipIfPreviousSkipped(!skipIfPreviousSkipped)}
                name="monitoring_report[skip_if_previous_skipped]"
                yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
              />
            </div>
          ) : (
            <p>{skipIfPreviousSkipped ? I18n.t("option_yes") : I18n.t("option_no")}</p>
          )}
        </Col>

        <Col size="xs-12" className="mb-1">
          <PhaseSectionElement title_key='longest_delay_limit' />
          {editMode ? (
            <input
              type="number"
              className="form-control"
              name="monitoring_report[longest_delay_limit]"
              value={longestDelayLimit}
              onChange={(e) => {
                setLongestDelayLimit(e.target.value);
              }}
            />
          ) : (
            <p>{longestDelayLimit ? longestDelayLimit : <i>{I18n.t("none")}</i>}</p>
          )}
        </Col>

        { displayFormField('monitoring_report[deadline_reminders]', report) &&
          <Col size="xs-12" className="mb-1">
              <div>
                <PhaseSectionElement title_key='deadline_reminders' />
              </div>
              {
                editMode ? 
                <DeadlineReminderEdit deadlineReminders={deadlineReminders} setDeadlineReminders={setDeadlineReminders} afterOnly={true}/>
                : 
                deadlineReminders.length > 0 ? deadlineReminders.map((dr,idx) => <div key={'reminder-row-' + idx}>{`${Math.abs(dr)} ${Math.abs(dr) == 1 ? I18n.t('unit_day') : I18n.t('unit_days')} ${I18n.t(dr > 0 ? 'after' : 'before')}`}</div>) : <p><i>{I18n.t('none')}</i></p>
              }
          </Col> 
        }

        <Col size="xs-12" className="mb-1" >
          <PhaseSectionElement title_key='automatic_skip_review' />
          {editMode ? (
            <div>
              <ToggleSwitch
                isOn={automaticSkipReview}
                handleToggle={() => setAutomaticSkipReview(!automaticSkipReview)}
                name="monitoring_report[automatic_skip_review]"
                yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
              />
            </div>
          ) : (
            <p>{automaticSkipReview ? I18n.t("option_yes") : I18n.t("option_no")}</p>
          )}
        </Col>

        <Col size="xs-12" className="mb-1" >
          <PhaseSectionElement title_key='confirmation_email_processed_submissions' />
          {editMode ? (
            <div>
            { tenantConfirmEmailProcessedSub ? 
                <Tooltip title={I18n.t("confirm_email_processed_already_tenant_level")}>
                  <ToggleSwitch
                    isOn={true}
                    disabled={true}
                    yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                    noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
                  />
                </Tooltip> 
                :
                <ToggleSwitch
                  isOn={confirmEmailProcessedSubmission}
                  handleToggle={() => setConfirmEmailProcessedSubmission(!confirmEmailProcessedSubmission)}
                  name="monitoring_report[confirm_email_processed_submission]"
                  yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                  noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
                />
            }
          </div>
            ) : (
              <p>{confirmEmailProcessedSubmission ? I18n.t("option_yes") : I18n.t("option_no")}</p>
            )}
        </Col>

        <Col size="xs-12" className="mb-1" >
          <PhaseSectionElement title_key='lock_form_fill' />
          {editMode ? (
            <div>
              <ToggleSwitch
                isOn={lockFormFill}
                handleToggle={() => setLockFormFill(!lockFormFill)}
                name="monitoring_report[lock_form_fill]"
                yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
              />
          </div>
            ) : (
              <p>{lockFormFill ? I18n.t("option_yes") : I18n.t("option_no")}</p>
            )}
        </Col>

        <Col size="xs-12" className="mb-1">
          <h3 style={{ display: "inline-block" }}>{I18n.t("permissions")}</h3>
        </Col>

        <Col size="xs-12" className="mb-1">
          <div>
            <label>{I18n.t("visible_report_forms")}</label>
          </div>
          {editMode ? (
            <Select
              name="monitoring_report[visible_forms][]"
              options={(fillPhase.forms || []).map((f) => ({
                value: f.id,
                label: f.name[I18n.locale],
              }))}
              value={visibleForms}
              onChange={handleVisibleFormSelect}
              isMulti
            />
          ) : visibleForms.length == 0 ? (
            <p>{I18n.t("all")}</p>
          ) : (
            <ReadOnlyMultiSelectValues
              values={visibleForms
                .map((pid) => fillPhase.forms.find((f) => f.id.toString() == pid))
                .filter((f) => f)
                .map((f) => ({ label: f.name[I18n.locale] }))}
            />
          )}
          {editMode && <p className="description">{I18n.t("visible_forms_description")}</p>}
        </Col>

        <Col size="xs-12" className="mb-1">
          <PhaseSectionElement title_key='is_allowed_to_modify_report' />
          {editMode ? (
            <div>
              <ToggleSwitch
                isOn={mayEditReport}
                handleToggle={handleMayEditReportToggle}
                name="monitoring_report[may_edit_report]"
                disabled={false}
                yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
              />
            </div>
          ) : (
            <p>{mayEditReport ? I18n.t("option_yes") : I18n.t("option_no")}</p>
          )}
        </Col>

        {displayFormField("monitoring_report[allow_proceed_as_reviewed]", report) && (
          <Col size='xs-12' className='mb-1'>
            <label>{I18n.t("allow_proceed_as_reviewed")}</label>
            {editMode ? (
              <div>
                <ToggleSwitch
                  isOn={mayProceedAsReviewed}
                  handleToggle={() => setMayProceedAsReviewed(!mayProceedAsReviewed)}
                  name="monitoring_report[allow_proceed_as_reviewed]"
                  yesElem={<TextOptionElem side="left" text={I18n.t("option_yes")} />}
                  noElem={<TextOptionElem side="right" text={I18n.t("option_no")} />}
                />
              </div>
            ) : (
              <p>{mayProceedAsReviewed ? I18n.t("option_yes") : I18n.t("option_no")}</p>
            )}
          </Col>
        )}

    </form>
    </Row>
  </>
  );
}

const CommentPhaseEdit = (props) => {
  const [isAdvancedShown, setIsAdvancedShown] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const { report, dispatch, phase, fillPhase, formOptions } = props;

  const generalFormRef = useRef(null);
  const advancedFormRef = useRef(null);
  
  return (
    <>
      <GeneralDetails {...props} generalFormRef={generalFormRef} advancedFormRef={advancedFormRef} editMode={editMode} setEditMode={setEditMode} />
      <PhaseCollapser isCollapsed={!isAdvancedShown} handleClick={() => setIsAdvancedShown(!isAdvancedShown)} />
      <div className={`${isAdvancedShown ? '' : 'hidden'}`}>
        <AdvancedOptions
          {...props}
          report={report}
          phase={phase}
          dispatch={dispatch}
          fillPhase={fillPhase}
          formRef={advancedFormRef}
          editMode={editMode}
          formOptions={formOptions}
        />
      </div>
      <FormList {...props} /><hr />
      <div className={`${isAdvancedShown ? '' : 'visibility-hidden'}`}>
        {displayPreFillContent(report.report_type) && <>
        <PreFillContextList phase={phase} report={report} dispatch={dispatch} availablePreFillContexts={formOptions.available_prefill_contexts} /><hr />
        </>}
        <FormDataCaptureList {...{phase, report, dispatch}} />
      </div>
    </>
  );
};

export default CommentPhaseEdit;
